import { AutoComplete } from '@components/Autocomplete';
import { Popover } from '@components/Popover';
import { FeatureFlags } from '@constants/featureFlags';
import { isFeatureFlagEnabled } from '@store/featureFlags/store';
import { fetchUserInfo, orderStore, setOrderStore } from '@store/orders';
import { UserDetailsType } from '@store/userDetails';
import { ReassignContactCard } from '@atgfr8/atg-ui-tailwind';
import { AccountCircleIcon } from '@atgfr8/icons';
import { createEffect, createSignal, Show } from 'solid-js';

import { isCustomerPresent } from './CustomerContactInformationDetails';

const getOperationsRepContact = () => {
  const operationsRep = orderStore.order.operationsRep;

  if (!operationsRep) {
    return undefined;
  }

  return {
    name: operationsRep.name ?? '-',
    phone1: operationsRep.phone1,
    phone1Ext: operationsRep.phone1Ext,
    email: operationsRep.email,
    fax: operationsRep.fax,
    office: operationsRep.office,
    accountingGroup: operationsRep.accountingGroup,
  };
};

const stylingHelper = () => {
  if (isCustomerPresent()) {
    return {
      color: '#016fa1',
    };
  }
  return { color: '#919495' };
};

export const OperationsRep = () => {
  createEffect(async () => {
    if (Boolean(orderStore.order.operationsId)) {
      const response = await fetchUserInfo(
        orderStore.order.operationsId as number,
      );
      setOrderStore('order', 'operationsRep', {
        office: response.office,
        name: response.name,
        phone1: response.phone1,
        email: response.email,
        accountingGroup: response.accountingGroup ?? '',
      });
    }
  });
  const [nameQuery, setNameQuery] = createSignal('');
  return (
    <Show when={isFeatureFlagEnabled(FeatureFlags.OperationsRep)()}>
      <div class="flex text-sm items-center">
        <div class="text-[#666666] w-[25%]">Operations Rep</div>
        <Popover
          eleName={
            <div class="flex items-center">
              <AccountCircleIcon size={20} style={stylingHelper()} />
              <Show when={orderStore.order.operationsRep}>
                <div class="ml-2 text-small text-[#1B4960]">
                  {orderStore.order.operationsRep?.name}
                </div>
              </Show>
            </div>
          }
          sxProps={{
            'text-transform': 'none',
            padding: '0px',
            'min-width': '0px',
            'pointer-events': isCustomerPresent() ? 'auto' : 'none',
          }}
          class="hover:bg-none"
        >
          <div class="min-w-[400px] p-2">
            <ReassignContactCard contact={getOperationsRepContact()} />
          </div>
        </Popover>
        <Popover eleName={<div class="text-[#026EA1] text-sm">REASSIGN</div>}>
          <div class="p-2">
            <div class="min-w-[400px] p-2">
              <ReassignContactCard contact={getOperationsRepContact()} />
            </div>
            <div class="py-2">
              <AutoComplete<UserDetailsType>
                endpoint="user/autocomplete?term"
                id="auto-complete-operations-rep"
                value={nameQuery()}
                onInput={(e: Event) =>
                  setNameQuery((e.target as HTMLInputElement).value)
                }
                onItemSelect={(item: UserDetailsType) => {
                  setOrderStore('order', 'operationsId', item.id);
                  setOrderStore('order', 'operationsRep', item);
                  setNameQuery(item.name ?? '');
                  if (!orderStore.isCreate) {
                    setOrderStore('order', 'operationType', 'Update');
                  }
                }}
                onClearValue={() => {
                  setNameQuery('');
                  setOrderStore('order', 'operationsRep', null);
                  setOrderStore('order', 'operationsId', null);
                  if (!orderStore.isCreate) {
                    setOrderStore('order', 'operationType', 'Update');
                  }
                }}
                placeholder="Search Operations Rep"
                class="w-full border-x-0! border-t-0! rounded-none! border-b! border-b-[rgba(0,0,0,0.42)]! hover:border-b-[rgba(0,0,0,0.87)]! focus-within:outline-none! focus-within:border-x-0! focus-within:border-t-0! focus-within:border-b-2! focus-within:border-b-[#1B4960]! [&>input::placeholder]:text-[rgba(0,0,0,0.38)]! [&:focus-within>input::placeholder]:text-[rgba(0,0,0,0.38)]!"
                disabled={orderStore.isReadOnly}
              />
            </div>
          </div>
        </Popover>
      </div>
    </Show>
  );
};

export default OperationsRep;
